module.exports = [{
      plugin: require('/Users/vojtechholik/Documents/Work/egghead/Dev/how-to-egghead/node_modules/gatsby-mdx/gatsby-browser'),
      options: {"plugins":[],"defaultLayouts":{"default":"/Users/vojtechholik/Documents/Work/egghead/Dev/how-to-egghead/src/components/Layout.js"},"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":960,"sizeByPixelDensity":true}}]},
    },{
      plugin: require('/Users/vojtechholik/Documents/Work/egghead/Dev/how-to-egghead/node_modules/gatsby-plugin-typography/gatsby-browser'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    }]
